import { Link as UILink } from '@travel/traveler-core/components/Link';

import { pushLocation } from 'promotions/store/__router/actions';
import { getHost, getProtocol } from 'promotions/store/__router/selectors';

// Re-export types from traveler-core
export type { Props } from '@travel/traveler-core/components/Link';
export { getHref } from '@travel/traveler-core/components/Link';

// Create Link with promotions-specific dependencies
export const Link = UILink({
  pushLocation,
  getHost,
  getProtocol,
});

export default Link;
